export default __webpack_public_path__ + "static/media/replay.c26afebb.svg";